<template>
  <div class="activity-rules">
      <!-- header -->
      <div class="header-top">
          <img class="left-cancel" @click="$router.push(`/ceping80?pageNum=${$route.query.pageNum}`)" src="@a/ceping80/left-cancel.png" alt="">
          <div class="userInfo">
            <img :src="userinfo.headimgurl" class="userImg" alt="">
            <p class="title">探索币(个)</p>
            <p class="small">{{userinfo.score}}</p>
          </div>
      </div>
      <!--  -->
      <div class="rules-box">
          <div class="header">
            <div :class="['left',tabShow==1?'on':'']" @click="tabHandle(1)">邀请记录</div>
            <div :class="['right',tabShow==2?'on':'']" @click="tabHandle(2)">消耗记录</div>
          </div>
          <!--  -->
          <div class="main">
              <!-- 邀请记录 -->
            <template v-if="tabShow==1">
                <div v-if="invite_list.length==0" class="left on">
                    哎呀~，暂无邀请记录
                </div>
                <div v-else v-for="(item,index) in invite_list" :key="index" class="left">
                    <img :src="item.headimgurl" class="u-img" alt="">
                    <span class="title text-ellipsis">{{item.nickname}}</span>
                    <span class="time">{{item.create_time}}</span>
                    <span class="num">+{{item.score}}</span>
                </div>

                
                <!-- 
                <div class="left">
                    <img class="u-img" alt="">
                    <span class="title">十一</span>
                    <span class="time">2020.12.22 16：59</span>
                    <span class="num">+50</span>
                </div>
                <div class="left">
                    <img class="u-img" alt="">
                    <span class="title">十一</span>
                    <span class="time">2020.12.22 16：59</span>
                    <span class="num">+50</span>
                </div> -->
            </template>
            <!-- 消耗记录 -->
            <template v-if="tabShow==2">
                <div v-if="activity_list.length==0" class="right on">
                    哎呀~，暂无消费记录
                </div>
                <div v-else v-for="(item,index) in activity_list" :key="index" class="right">
                    <img src="@a/ceping80/rules-money.png" class="u-img" alt="">
                    <span class="time">{{item.create_time}}</span>
                    <span class="num">-{{item.score}}</span>
                </div>
                <!-- <div class="right">
                    <img src="@a/ceping80/rules-money.png" class="u-img" alt="">
                    <span class="time">2020.12.22 16：59</span>
                    <span class="num">-50</span>
                </div>
                <div class="right">
                    <img src="@a/ceping80/rules-money.png" class="u-img" alt="">
                    <span class="time">2020.12.22 16：59</span>
                    <span class="num">-50</span>
                </div>
                <div class="right">
                    <img src="@a/ceping80/rules-money.png" class="u-img" alt="">
                    <span class="time">2020.12.22 16：59</span>
                    <span class="num">-50</span>
                </div> -->

            </template>
          </div>
      </div>
      <!-- 规则介绍说明 -->
      <div class="rules-des">
        <img class="title" src="@a/ceping80/rules-title.png" alt="">
        <p>1.用户可获得300个探索币，用于海岛寻宝活动。</p>
        <p>2.探索币目前可用于支付登岛费用、景点门票，更多功能敬请期待。</p>
        <p>3.可以通过邀请新人获得探索币，每邀请1人获得100探索币，新人指的是未关注公众号的用户。</p>
        <p>4.活动解释权归新精英所有。</p>
      </div>
  </div>
</template>

<script>
import { ceping80_info,ceping80_invite_log,ceping80_activity_log } from "@/api/measurement";
export default {
    data(){
        return{
            tabShow:1,
            userinfo:{},
            invite_list:[],
            activity_list:[]
        }
    },
    methods:{
        /*
         *@param: val：1 邀请记录、2 消费记录
         *@return: 
         *@Description: 点击的是哪个tab标签页
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-23 16:21:57
        */
        tabHandle(val){
            if(val==1){
                this.getInviteLog();
            }else{
                this.getActivityLog();
            }
            this.tabShow = val;
        },
        /*
         *@param: 
         *@return: 
         *@Description: 获取邀请记录
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-23 16:17:51
        */
        getInviteLog(){
            ceping80_invite_log().then((data)=>{
                if (data.code == "10002") {
                    this.$toast(data.msg);
                    return
                }
                this.invite_list = data.list;
            });
        },
        /*
         *@param: 
         *@return: 
         *@Description: 获取消费记录
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-23 16:19:48
        */
        getActivityLog(){
            ceping80_activity_log().then((data)=>{
                if (data.code == "10002") {
                    this.$toast(data.msg);
                    return
                }
                this.activity_list = data.list;
            });
        },
        /*
         *@param: 
         *@return: 
         *@Description: 初始化请求数据
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-23 16:16:45
        */
        pullData(){
            //调用加载中
            this.$emit("loadingHandle", true, "拼命加载中...");
            // 请求个人信息和邀请记录接口
            ceping80_info().then((data)=>{
                if (data.code == "10002") {
                    this.$toast(data.msg);
                    return
                }
                document.title = '海岛历险';
                //关闭加载中
                this.$emit("loadingHandle", false);
                this.userinfo = data;
            }).catch(err=>{
                //关闭加载中
                this.$emit("loadingHandle", false);
            });
            this.getInviteLog();
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.activity-rules{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100%;
    background: linear-gradient(180deg, #E2F7FF 0%, #9AF8FF 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
    overflow-x: hidden;
    .header-top{
        background: url(../../../assets/ceping80/rules-header.png) center no-repeat;
        background-size: cover;
        height: 350px;
        width: 100%;
        max-width: 750px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 80px 0px 30px;
        .left-cancel{
            position: absolute;
            top: 33px;
            left: 30px;
            width: 71px;
            height: 73px;
        }
        .userInfo{
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            .userImg{
                width: 120px;
                height: 120px;
                border-radius: 50%;
                background-color: #ffffff;
                border: 2px solid #ffffff;
                margin-bottom: 30px;
            }
            .title{
                font-size: 30px;
                color: #ffffff;
                text-align: center;
                line-height: 1;
                margin-bottom: 20px;
            }
            .small{
                text-align: center;
                font-size: 48px;
                color: #ffffff;
                line-height: 1;
            }
        }
    }
    .rules-box{
        width: 670px;
        background: #FFFFFF;
        border-radius:40px;
        overflow: hidden;
        margin-top:40px ;
        font-size: 0;
        .header{
            background-color: #f9f9f9;
            line-height: 80px;
            height: 80px;
            color: #C3C8D0;
            font-size: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            .left{
                flex: 1;
            }
            .left.on{
                background: url(../../../assets/ceping80/tab-left.png) center no-repeat;
                background-size: cover;
                color: #029BFF;
                font-weight: bold;
            }
            .right{
                flex: 1;
            }
            .right.on{
                background: url(../../../assets/ceping80/tab-right.png) center no-repeat;
                background-size: cover;
                color: #029BFF;
                font-weight: bold;
            }

        }
        .main{
            padding: 30px;
            .left{
                display: flex;
                align-items: center;
                margin-bottom: 20px;
                &:last-child{
                    margin-bottom: 30px;
                }
                .u-img{
                    width: 64px;
                    height: 64px;
                    border-radius: 50%;
                    margin-right: 14px;
                    background-color: #f9f9f9;
                }
                .title{
                    display: block;
                    width: 130px;
                    font-size: 26px;
                    color: #2B333A;
                    font-weight: bold;
                    margin-right:20px;
                }
                .time{
                    font-size: 22px;
                    color: #A9AFB3;
                    margin-right: auto;
                }
                .num{
                    font-size: 26px;
                    color: #FF5555;
                }
            }
            .left.on{
                font-size: 28px;
                text-align: center;
                justify-content: center;
                color: #C3C8D0;
            }
            .right{
                display: flex;
                align-items: center;
                margin-bottom: 40px;
                &:last-child{
                    margin-bottom: 30px;
                }
                .u-img{
                    width: 44px;
                    height: 44px;
                    border-radius: 50%;
                    margin-right: 10px;
                    background-color: #f9f9f9;
                }
                .time{
                    font-size: 22px;
                    color: #A9AFB3;
                    margin-right: auto;
                }
                .num{
                    font-size: 26px;
                    color: #FF5555;
                }
            }
            .right.on{
                font-size: 28px;
                text-align: center;
                justify-content: center;
                color: #C3C8D0;
            }
        }
    }
    .rules-des{
        width: 670px;
        background: #FFFFFF;
        border-radius: 40px;
        padding: 60px 30px;
        margin-top: 40px;
        margin-bottom: 60px;
        .title{
            width: 392px;
            height: 40px;
            display: block;
            margin: 0 auto 35px;
        }
        p{
            font-size: 26px;
            color: #7F848B;
            line-height: 36px;
            margin-bottom: 30px;
        }
    }
}
</style>